module.exports = __webpack_public_path__ + "static/media/farmx_logo_white.9956491b.png";